import reqest from "../common/reqest";

/**
 * 子账户列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getSubAccount(data) {
  return reqest.send("/Subaccount/Subaccount_Lists", data)
}

/**
 * 添加子账户
 * @param data
 * @returns {Promise<unknown>}
 */
export function addSubAccount(data) {
  return reqest.send("/Subaccount/Subaccount_Add", data)
}

/**
 * 删除子账户
 * @param data
 * @returns {Promise<unknown>}
 */
export function delSubAccount(data) {
  return reqest.send("/Subaccount/Subaccount_Del", data)
}